<template>
  <v-data-table
    :headers="headers"
    :items="toolOrders"
    :search="search"
    :items-per-page="10"
    :loading="loading"
    loading-text="Loading Tool Orders..."
  >
    <template v-slot:top v-if="admin">
      <v-toolbar flat color="white" class="pt-1">
        <v-text-field
          v-model="search"
          append-icon="search"
          label="Filter by site address"
          hide-details
          outlined
          dense
        ></v-text-field>
      </v-toolbar>
    </template>
    <template v-slot:item.orderNumber="{ item }">
      <span class="subtitle-2">#{{ item.orderNumber }}</span>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon small class="ml-1" v-if="item.notes" v-on="on"
            >description</v-icon
          >
        </template>
        <span>This order has a note</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on }">
          <v-icon
            small
            class="ml-1"
            v-if="item.tools.find((t) => t.isRental)"
            v-on="on"
            >monetization_on</v-icon
          >
        </template>
        <span>This order includes rentals</span>
      </v-tooltip>
    </template>
    <template v-slot:item.jobSite="{ item }">
      <div style="line-height:16px">
        <span
          v-if="item.jobSite.entity"
          class="caption grey--text text--darken-1 mr-1"
          >({{ item.jobSite.entity }})</span
        >{{ item.jobSite.street }}
      </div>
    </template>
    <template v-slot:item.orderedBy="{ item }"
      >{{ item.orderedBy.firstName }} {{ item.orderedBy.lastName }}</template
    >
    <template v-slot:item.fulfilled="{ item }">
      <div v-if="item.fulfilled && !item.cancelled">
        <v-chip small>
          <v-icon left small class="pl-1">local_shipping</v-icon>Fulfilled
        </v-chip>
      </div>
      <div v-if="item.cancelled">
        <v-chip small>
          <v-icon left small class="pl-1">close</v-icon>Cancelled
        </v-chip>
      </div>
      <v-chip
        small
        color="amber lighten-3"
        v-if="!item.fulfilled && !item.cancelled"
      >
        <v-icon left small class="pl-1">panorama_fish_eye</v-icon>Unfulfilled
      </v-chip>
    </template>
    <template v-slot:item.fulfillmentDate="{ item }">
      <div v-if="item.fulfilled">
        <div class="grey--text" style="font-size:12px;margin-left:10px">
          {{ item.fulfillmentDate.toDate() | moment("MMM Do h:mma") }}
        </div>
        <div
          v-if="item.fulfilledBy"
          class="grey--text"
          style="font-size:12px;margin-left:10px"
        >
          by {{ item.fulfilledBy.firstName }} {{ item.fulfilledBy.lastName }}
        </div>
      </div>
    </template>
    <template v-slot:item.requestDay="{ item }">
      <div v-if="item.requestDay">
        {{ item.requestDay.displayDate }} {{ item.requestTime }}
      </div>
    </template>
    <template v-slot:item.orderDate="{ item }">{{
      item.orderDate.toDate() | moment("MMM Do [at] h:mma")
    }}</template>
    <template v-slot:item.viewOrder="{ item }">
      <v-btn
        color="primary"
        small
        outlined
        text
        :to="
          admin
            ? `/tools/manage/orders/${item.orderNumber}`
            : `/tools/orders/${item.orderNumber}`
        "
        >view order</v-btn
      >
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: ["toolOrders", "admin", "loading", "headers"],
  data() {
    return {
      search: "",
    };
  },
};
</script>
